<template>
  <div class="pa-4 pa-md-5">
    <!-- Botón Volver -->
    <v-btn @click="$router.back()" class="back-btn mb-3">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <!-- Contenedor Principal de la Tabla de Miembros -->
    <v-col cols="12" class="pa-0">
      <tabla
        :Titulo="title"
        :Cabecera="Cabecera"
        :Items="items"
        :Roles="roles"
        :loading="loader"
        :Excel="true"
        :Crear="true"
      />
    </v-col>
  </div>
</template>

<script>
import tabla from "@/components/miembros/tabla.vue";
import { axios2 as axios } from "@/interceptor/useApi";

export default {
  name: "Miembros",
  components: {
    tabla
  },
  provide() {
    return {
      llamarindexMembers: this.indexMembers
    };
  },
  data() {
    return {
      items: [],
      roles: [],
      itemTotal: 0,
      Cabecera: [
        {
          text: "Nombre y Apellidos",
          value: "name",
          align: "left"
        },
        {
          text: "Correo Electrónico",
          value: "email",
          align: "left"
        },
        {
          text: "Rol Asignado",
          value: "role",
          align: "left",
          width: 180
        },
        {
          text: "Acciones",
          value: "accion",
          align: "center",
          sortable: false,
          width: 140
        }
      ],
      loader: false,
      title: "",
      cliente: null
    };
  },
  methods: {
    indexMembers: async function (id_cliente) {
      try {
        this.loader = true;
        const url = "userclientes/index";
        const datos = {
          id_cliente: id_cliente
        };
        await axios
          .post(url, datos)
          .then(response => {
            this.loader = false;
            this.items = response.data.success.miembros;
            this.cliente = response.data.success.cliente;
            this.itemTotal = response.data.success.miembros.length;
            this.title = "Miembros de: " + (this.cliente ? this.cliente.razon_social : "Cliente");
            let arrayroles = response.data.success.roles;

            this.roles = [];
            arrayroles.forEach(element => {
              if (element.id == 4 || element.id == 5) {
                this.roles.push({
                  value: element.id,
                  text: element.name
                });
              }
            });
          })
          .catch(error => {
            this.loader = false;
            this.errorMessage = error.response.data;
            console.error("error!", error);
          });
      } catch (error) {
        this.loader = false;
        console.log(error);
      }
    }
  },
  async created() {
    let id_cliente = location.pathname.substr(1).split("/")[1];
    this.indexMembers(id_cliente);
  }
};
</script>
